import React, { useState, useEffect, useRef } from 'react';

const MultiSelectDropdown = ({ 
  options,          // список { id, name }
  selectedIds,      // массив выбранных id
  onChange,         // callback для изменения выбора
  placeholderAll,   // текст когда выбраны все
  placeholderOne,   // текст когда выбрано одно
  placeholderMany   // текст-шаблон для "(N) выбрано"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSelect = (id) => {
    if (selectedIds.includes(id)) {
      onChange(selectedIds.filter(x => x !== id));
    } else {
      onChange([...selectedIds, id]);
    }
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const renderButtonText = () => {
    if (selectedIds.length === 0 || selectedIds.length === options.length) {
      return placeholderAll;
    }
    if (selectedIds.length === 1) {
      const item = options.find(o => o.id === selectedIds[0]);
      return item ? item.name : placeholderOne;
    }
    return `${selectedIds.length} ${placeholderMany}`;
  };

  return (
    <div className="dropdown" ref={dropdownRef}>
      <button 
        className="btn btn-outline-secondary w-100 text-start"
        type="button"
        onClick={toggleDropdown}
      >
        {renderButtonText()}
      </button>
      {isOpen && (
        <div className="dropdown-menu show w-100" style={{ maxHeight: "300px", overflowY: "auto" }}>
          {options.map(option => (
            <label key={option.id} className="dropdown-item">
              <input
                type="checkbox"
                checked={selectedIds.includes(option.id)}
                onChange={() => handleSelect(option.id)}
              />
              {' '}{option.name}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiSelectDropdown;
